import type {WebsiteModuleTerms} from "../../../../apps/website/website-module.terms";
import type {EntityDescriptionSectionViewModel} from "../../../../domain/entity-description/models/section/entity-description.section.view-model";
import {MetadataPageBaseModel} from "../../../../core/models/metatdata/metadata-page.base-model";
import {METADATA_FILTERS} from "../../../../core/models/metatdata/metadata-filters.consts";
import type {SportDomainModel} from "../../../../domain/sports/models/sport-domain-model";
import {SPORT_TYPES} from "../../../../core/app/consts";
import {DASHBOARD} from "../../../dashboard-container/dashboard-container.consts";
import {DatetimeUtils} from "../../../../infrastructure/utils/datetime-utils";

export class AllScoresRoutePageModel extends MetadataPageBaseModel {
  constructor(
    section: EntityDescriptionSectionViewModel,
    terms: WebsiteModuleTerms,
    datetimeUtils: DatetimeUtils,
    date: String,
    sportType: SportDomainModel,
    isLive: Boolean,
  ) {
    super(section, terms);

    this.datetimeUtils = datetimeUtils
    this.sportType = sportType
    this.date = date
    this.isLive = isLive
  }

  get mainValue(): String {
    return this.section?.getElementValue(METADATA_FILTERS.ALL_SCORES.main)
  }

  get liveValue(): String {
    return this.section?.getElementValue(METADATA_FILTERS.ALL_SCORES.live)
  }

  get yesterdayValue(): String {
    return this.section?.getElementValue(METADATA_FILTERS.ALL_SCORES.yesterday)
  }

  get tomorrowValue(): String {
    return this.section?.getElementValue(METADATA_FILTERS.ALL_SCORES.tomorrow)
  }

  get matchResultsValue(): String {
    return this.section?.getElementValue(METADATA_FILTERS.ALL_SCORES.matchResults)
  }

  get matchFixturesValue(): String {
    return this.section?.getElementValue(METADATA_FILTERS.ALL_SCORES.matchFixtures)
  }

  get isHomePage(): Boolean {
    return this.sportType?.id === SPORT_TYPES.football;
  }

  get isOnTv(): Boolean {
    return this.sportType?.id === SPORT_TYPES.onTv;
  }

  get isToday(): Boolean {
    return this.date === DASHBOARD.FILTERS.all || this.isLive;
  }

  get isYesterday(): Boolean {
    return this.date === DASHBOARD.FILTERS.yesterday
  }

  get isTomorrow(): Boolean {
    return this.date === DASHBOARD.FILTERS.tomorrow
  }

  get isBeforeYesterday(): Boolean {
    return this.date === DASHBOARD.FILTERS.results
  }

  get isAfterTomorrow(): Boolean {
    return this.date === DASHBOARD.FILTERS.fixtures
  }

  get shortestDate() {
    return !this.isYesterday && !this.isToday && !this.isTomorrow && !this.isLive ? this.datetimeUtils.toShortestDate(this.date) : null
  }
}